export default "__VITE_ASSET__vAbIdWlf__"